import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import Icon from 'react-native-vector-icons/Ionicons';
import { PADDING, ICON_SIZES } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { WifiSupportOption, WifiSupportType } from '@/types/residents/wifi';

interface WifiSupportRowProps {
  option: WifiSupportOption;
  onPress: (type: WifiSupportType, value: string) => void;
}

export const WifiSupportRow: React.FC<WifiSupportRowProps> = ({
  option,
  onPress,
}) => {
  const { colors } = useThemeColors();

  const handlePress = () => {
    onPress(option.type, option.value);
  };

  const getIconName = () => {
    switch (option.type) {
      case WifiSupportType.TEXT:
        return 'chatbubble-outline'; // iOS: .Icon.comment
      case WifiSupportType.EMAIL:
        return 'mail-outline'; // iOS: .Icon.mailOutline
      case WifiSupportType.WEBSITE:
        return 'globe-outline';
      default:
        return 'help-circle-outline';
    }
  };

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={handlePress}
      accessibilityRole="button"
      accessibilityLabel={`${option.title}: ${option.value}`}
      accessibilityHint={`Tap to ${option.type === WifiSupportType.TEXT ? 'send text message' : option.type === WifiSupportType.EMAIL ? 'send email' : 'open website'}`}
    >
      <View style={[styles.iconContainer, { backgroundColor: colors.accent.blueBgLight }]}>
        <Icon
          name={getIconName()}
          size={ICON_SIZES.medium}
          color={colors.text.subtle}
        />
      </View>
      <View style={styles.textContainer}>
        <Text style={[styles.title, { color: colors.text.subtle }]}>{option.title}</Text>
        <Text style={[styles.value, { color: colors.text.primary }]}>{option.value}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: PADDING.padding4,
    minHeight: 60,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: PADDING.padding3,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontSize: 13,
    fontWeight: '400',
    marginBottom: 2,
  },
  value: {
    fontSize: 15,
    fontWeight: '400',
  },
});